<template>
  <div id="app">
    <router-view v-if="customizeInfo"/>
  </div>
</template>

<script>
import {mapState, mapActions} from 'vuex'
import browserUtils from './util/browserUtils'
export default {
  name: 'App',
  computed: mapState({
    customizeInfo: state => state.customize.info
  }),
  methods: {
    ...mapActions(['setCustomizeInfo']),
    loadCustomizeInfo () {
      this.$ajax({
        url: '/index/home/custom/customizeInfo',
        method: 'post'
      }).then(response => {
        this.setCustomizeInfo(response.data || {})
          .then(() => {})
      }, () => {
        this.setCustomizeInfo({})
      })
    },
    isHomePageUrl () {
      let pathname = window.location.pathname
      if (pathname === '/') {
        return true
      } else {
        let base = this.$router.options.base || '/'
        if (pathname.startsWith(base)) {
          let path = pathname.substring(base.length - 1)
          return !path || path === '/'
        }
      }
    }
  },
  mounted () {
    if (this.isHomePageUrl() && browserUtils.isMobile()) {
      window.location.href = this.$contextPath('/static/app/wechat/')
    } else {
      this.loadCustomizeInfo()
    }
  }
}
</script>

<style lang="scss">
  /* 引入样式 */
  @use "styles/index" as *;

  #app {
    width: 100%;
    height: 100%;
  }
</style>
